import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { getActiveLocaleSelector } from '@americanexpress/travel-selectors';
import getDynatraceDetails from '../../selectors/dynatraceSelectors';

const Dynatrace = ({ getActiveLocale }) => {
  const {
    src: dynatraceSrc,
  } = getDynatraceDetails(getActiveLocale);

  React.useEffect(() => {
    const dynatrace = document.createElement('script');
    dynatrace.setAttribute('type', 'text/javascript');
    dynatrace.setAttribute('src', dynatraceSrc);
    dynatrace.setAttribute('crossOrigin', 'anonymous');
    document.body.append(dynatrace);
    return () => {
      dynatrace.remove();
    };
  }, [dynatraceSrc]);

  return null;
};

Dynatrace.propTypes = {
  getActiveLocale: PropTypes.string,
};

const mapStateToProps = createStructuredSelector({
  getActiveLocale: getActiveLocaleSelector,
});

export { Dynatrace as TestableDynatrace };

export default connect(mapStateToProps, null)(Dynatrace);
